var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"featurebadge"},[_c('div',{staticClass:"line-1"},[_vm._v(_vm._s(_vm.lines[0] || ''))]),_c('div',{staticClass:"line-2"},[_vm._v(_vm._s(_vm.lines[1] || ''))]),_c('div',{staticClass:"line-3"},[_vm._v(_vm._s(_vm.lines[2] || ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }